module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8mBZw"))).then(() => parcelRequire('1iHdE'));